import { createFileRoute } from "@tanstack/react-router";
import { ActivitiesStep } from "#/modules/les.planning/components/preparation-steps";
import { activitiesStepOptions } from "#/modules/les.planning/preparation-routes";

export const Route = createFileRoute(
  "/$locale/{-$schoolyear}/_authenticated/$school/lesson/$lesson/teacher/notities/les/activities",
)({ ...activitiesStepOptions, component: Step });

function Step() {
  const navigate = Route.useNavigate();
  return (
    <ActivitiesStep
      data={Route.useLoaderData()}
      search={Route.useSearch()}
      onChange={(patch) =>
        void navigate({
          search: (prev) => ({ ...prev, ...patch }),
          replace: true,
          resetScroll: false,
        })
      }
    />
  );
}
